var CWAddToCart = (function ($) {

    var bindAddToCart = function (sel) {
        if (!$(sel).length){
            return;
        }

        $(document).on("submit", sel, function(event){
            event.preventDefault();
            var $form = $(event.target);
            var url = $form.attr('action');

            if (!url){
                return;
            }

            var token = $("input[name='_csrf']").val();
            var code = $form.find("input[name=wheelId]").val();
            var quantity = $form.find(".ranzahl, .tireNumberSelect").first().find(":selected").val();
            var header = "X-CSRF-TOKEN";
            var productCartData = {
                "items": [{ "code": code, "quantity": quantity }],
                "price": '',
                "discountedPrice": ''
            };

            $.ajax({
                url: url,
                type: "POST",
                data: $form.serialize(),
                beforeSend: function(xhr) {
                    xhr.setRequestHeader(header, token);
                },
                success: function() {
                    $( document ).trigger( "changeCartEvent", productCartData);
                }
            });
        });
    };

    return {
        bindAddToCart: bindAddToCart
    };
}) (jQuery);

$(document).ready(function() {
    //add listener for "add to cart" btn on cw PDP
    CWAddToCart.bindAddToCart("#complete_wheels_root .cw-add-to-cart-form");
});